import { render, staticRenderFns } from "./votePublic.vue?vue&type=template&id=67fd30fe&scoped=true&"
import script from "./votePublic.vue?vue&type=script&lang=js&"
export * from "./votePublic.vue?vue&type=script&lang=js&"
import style0 from "./votePublic.vue?vue&type=style&index=0&id=67fd30fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd30fe",
  null
  
)

export default component.exports